module.exports = __webpack_public_path__ + "static/img/3-5.ed1be89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/events/summer2018/app_screen/section-3/3-5.jpg
// module id = 740
// module chunks = 1